import { useApiClient as sharedUseApiClient } from "@timenotes/shared/src/services/api-client/api-client.hooks"

export const useApiClient = () => {
  const apiClient = sharedUseApiClient()

  return apiClient
}

export default useApiClient